import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export function ConnectTable(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M20 8v7l4-3.5L20 8zM4 8h12a2 2 0 012 2v3a2 2 0 01-2 2H4a2 2 0 01-2-2v-3a2 2 0 012-2zm0 5h5v-3H4v3m7 0h5v-3h-5v3" />
    </SvgIcon>
  );
}
